/* snoot: Hotspot Picture. A tapped marker opens its card; the markers cycle on their own until someone taps. */
(function () {
  function init(root) {
    if (root.__shd) return;
    root.__shd = true;
    var pins = [].slice.call(root.querySelectorAll('[data-shd-pin]'));
    var panels = [].slice.call(root.querySelectorAll('[data-shd-panel]'));
    var hint = root.querySelector('[data-shd-hint]');
    if (!pins.length) return;
    var cur = 0, timer = null, touched = false;
    function show(i) {
      cur = i;
      pins.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      var stack = window.matchMedia('(min-width: 900px)').matches;
      panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.hidden = !stack && k !== i; });
      root.querySelectorAll('[data-shd-spot]').forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      root.querySelectorAll('[data-shd-line]').forEach(function (l, k) { l.classList.toggle('is-on', k === i); });
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    panels.forEach(function (p, k) { p.addEventListener('click', function () { touched = true; stop(); show(k); }); });
    window.addEventListener('resize', function () { show(cur); });
    show(0);
    pins.forEach(function (p, k) {
      p.addEventListener('click', function () { touched = true; stop(); show(k); if (hint) hint.classList.add('is-hidden'); });
    });
    if (root.getAttribute('data-autoplay') === 'true' && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !timer && !touched) timer = setInterval(function () { show((cur + 1) % pins.length); }, 3800);
        else if (!es[0].isIntersecting) stop();
      }, { threshold: 0.4 }).observe(root);
    }
    root.addEventListener('shopify:block:select', function (e) {
      var p = e.target.closest('[data-shd-pin]'); if (p) { touched = true; stop(); show(pins.indexOf(p)); }
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-shd]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
